var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoTrainWhiteH16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 54,
  height: 16,
  viewBox: "0 0 54 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "8ctsf8pqqa",
  d: "M0 0h7.368v9H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mm11md9sqc",
  d: "M0 0h16.16v7.55H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h54v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M44.33 3.903c-.557 0-.79.199-.903.717l-1.342 8.283h2.904l1.564-9zm-33.92-.006H7.877c-.39 0-.611.124-.87.366L4.108 7.082l.7-3.185H2.515c-.548 0-.773.196-.884.702L.078 12.903h2.88l.792-3.911 2.683 3.91h3.587L6.448 7.815l3.962-3.917z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.554 3.903)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "77rwpd3gsb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8ctsf8pqqa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M3.282 6.89 4.466 0H2.244c-.548 0-.781.19-.898.687L0 9h7.097l.271-2.11z",
  mask: "url(#77rwpd3gsb)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m27.332 8.379.64-3.091h1.07s1.072-.065.688 1.38c0 0-.425 1.711-2.398 1.711m9.853-1.663 1.155 6.187h3.078l-1.892-9h-2.841c-.448 0-.634.127-.83.446l-3.718 7.359-2.568-2.32c1.164-.327 2.458-1.22 2.822-2.72.645-2.665-1.603-2.771-2.351-2.771h-4.128c-.534 0-.63.115-.742.6l-.794 3.735c-2.025-1.32-6.62-3.995-9.854-4.035-.814-.012-1.408.112-1.983.465-.087.055-.11.046-.12.043l.044-.093c.35-.424 1.059-1.11 2.255-1.48 0 0 1.909-.665 4.471.889a27.5 27.5 0 0 1 3.466 2.468c-.74-3.06-3.599-5.247-6.864-4.964a6.52 6.52 0 0 0-5.845 5.208c1.58-1.415 4.61-1.917 9.244-.333a33 33 0 0 1 2.88 1.137c.801.358 1.613.783 2.46 1.271 1.748 1.007 3.7 2.407 5.28 4.095h4.337z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.722 6.95)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3qx1iqidod",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mm11md9sqc"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M16.16 3.672c-.232 1.009-.477 2.281-.477 2.281H12.66l.688-3.237a23 23 0 0 0-1.363-.408c-.552 2.759-2.838 4.967-5.794 5.218a6.51 6.51 0 0 1-5.019-1.72l-.007-.007S-.092 4.655.005 3.003C.102 1.305 1.596.616 1.596.616 3.333-.314 7.18-.415 12.618 1.914c0 0 1.826.717 3.542 1.758",
  mask: "url(#3qx1iqidod)"
})))));
export default SvgLogoTrainWhiteH16;